/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = RepairOrderQuote
 *
 * 1 = CheckIn
 */
export enum EmailDeliveryOptionEnum {
  RepairOrderQuote = 0,
  CheckIn = 1,
}
